export const SystemUsers = {
  System: '167a79500000000000000001',
  AccountOwner: '167a79500000000000000002',
  AppBuilder: '167a79500000000000000003',
  SharedBuilder: '167a79500000000000000004',
  KnackSupportTeam: '167a79500000000000000005',
  PublicNotLoggedIn: '167a79500000000000000006',
  KnackAI: '167a79500000000000000007',
  Automation: '167a79500000000000000008'
};

export const SystemUsersIds = Object.values(SystemUsers);

